class RoDiscountCode extends HTMLElement {

  get discount() {
    return this.input.value;
  }

  constructor() {
    super();

    this.input = this.querySelector("input");
    this.button = this.querySelector("[data-apply]");
    this.discounts = (this.dataset.discounts || "").trim().split(',');

    this.label = this.querySelector('[data-label]');

  }

  connectedCallback() {
    this.setListeners();
  }

  setListeners() {
    this.button.addEventListener('click', () => {
      this.apply();
    });
  }

  async apply() {
    if (this.discounts.includes(this.discount)) {
      this.handleError(window.discountCode.used);
      return;
    }


    const finalDiscounts = [...this.discounts, this.discount].filter(value => value !== "");

    const body = JSON.stringify({
      discount: finalDiscounts.join(','),
      sections: this.getSectionsToRender().map(section => section.section)
    });

    const response = await fetch(window.routes.cart_update_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body
    });

    const result = await response.json();
    const isOk = result.discount_codes.find((discount) => {
      return discount.code === this.discount && discount.applicable === true;
    })

    if (!isOk) {
      this.handleError(window.discountCode.error);
      return;
    }

    this.handleSuccess();
    this.dataset.discounts = finalDiscounts.join(',');

    for (const section of this.getSectionsToRender()) {
      const text = result.sections[section.section];
      const newHtml = new DOMParser().parseFromString(text, 'text/html').querySelector(section.selector);
      document.querySelector(section.selector).innerHTML = newHtml.innerHTML;
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: 'ro-cart-items',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '[data-summary]',
      },
    ];
  }

  handleError(message) {
    this.label.toggleAttribute('data-error', true);
    this.label.toggleAttribute('data-success', false);

    this.label.innerHTML = message;
  }

  handleSuccess() {
    this.label.toggleAttribute('data-error', false);
    this.label.toggleAttribute('data-success', true);

    this.label.innerHTML = window.discountCode.success;
  }

}

customElements.define("ro-discount-code", RoDiscountCode);
